import MailFilledIcon from '@/assets/mail-filled.svg?react'
import { useIsMobile } from '@/utils/hooks/useMediaQuery'
import { useTimeout } from '@mantine/hooks'
import clsx from 'clsx'
import { useEffect, useState, type HTMLAttributes } from 'react'
import Tooltip from './Tooltip'
import styles from './UnreadNotificationTooltip.module.css'

export interface UnreadNotificationTooltipProps extends HTMLAttributes<HTMLDivElement> {
	data: number
}

export default function UnreadNotificationTooltip({
	data,
	className,
	...props
}: UnreadNotificationTooltipProps) {
	const isMobile = useIsMobile()
	const [opened, setOpened] = useState(false)
	const { start, clear } = useTimeout(() => void setOpened(false), 3000)

	useEffect(() => {
		if (data > 0) {
			setOpened(true)
			start()
		} else {
			setOpened(false)
			clear()
		}
		return clear
	}, [clear, data, start])

	return (
		<Tooltip
			opened={opened}
			position={isMobile ? 'bottom' : 'left'}
			offset={isMobile ? 10 : 20}
			content={
				<div className={styles.content}>
					<MailFilledIcon className={styles.icon} />
					<span>{data}</span>
				</div>
			}
		>
			<div className={clsx(styles.container, className)} {...props} />
		</Tooltip>
	)
}
